module.exports = __webpack_public_path__ + "img/who-we-are-home.96ffe38f.webp";